"use client";

import React from "react";
import Image, { type StaticImageData } from "next/image";
import { Icons } from "@/app/assets/assets";
import IndustryHeader from "../../../app/solution-landing-page/IndustryHeader";
import PrimaryBtn from "@/components/PrimaryBtn";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";

type ReasonItem = {
  icon: string | StaticImageData;
  title: string;
  description: string;
};

interface WhyKonstantLaravelDataProps {
  title: React.ReactNode;
  description: string;
  subtitle: string;
  reasonArray: ReasonItem[];
}

export default function WhyKonstantLaravel({
  title,
  description,
  subtitle,
  reasonArray = [],
}: WhyKonstantLaravelDataProps) {
  const { handleOpenQuote } = useTheme();
  return (
    <section className="2xl:py-[80px] py-[20px] pb-[40px] lg:pb-[0px] ">
      <IndustryHeader
        title={title}
        subtitle={subtitle}
        description={description}
        mode="light"
        button={
          <PrimaryBtn
            text="Let's talk with us"
            dark={false}
            iconSrc={Icons?.chevron}
            onClick={() => {
              handleOpenQuote();
            }}
          />
        }
      />
      <div className="w-[calc(100vw-10%)] max-w-[2500px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
          {reasonArray?.map((item, idx) => (
            <div
              key={idx}
              className="group relative flex flex-col gap-[24px] border border-[#ecf0f6] p-[28px] bg-white hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)] transition-shadow"
            >
              <div className="w-[66px] h-[66px]">
                <Image
                  src={item.icon}
                  alt={item.title}
                  width={66}
                  height={66}
                  className="object-contain "
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />
              </div>
              <div className="flex flex-col gap-[12px]">
                <h3 className="text-[#00040b] text-[clamp(0.9375rem,0.4664rem+0.9815vw,2rem)] leading-[120%] clash-font font-medium">
                  {item.title}
                </h3>
                <p
                  className="text-[#636364] text-[20px] leading-[140%]"
                  dangerouslySetInnerHTML={{ __html: item.description ?? "" }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
